import * as React from "react";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "./../../../services/utility/autoMapperService";
import BaseListComponent from "./../../../components/BaseListComponent";
import scoringCardService from "../../../services/creditAssessment/scoringCardService";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import TableFilterPane from "./../../../components/tableComponents/tableFilterPane";
import ScoreCardDetail from "./scoreCardDetail";
import { getCurrentUserSession, getCurrentUsersRoles } from "../../../services/auth/authService";
import EditScoreCard from "./editScoreCard";
import { decodeToken } from "react-jwt";

export interface ScoreCardsProps { }

export interface ScoreCardsState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
  institutionCode: string;
}

class ScoreCardsList extends BaseListComponent<ScoreCardsState> { }

class ScoreCards extends React.Component<ScoreCardsProps, ScoreCardsState> {
  constructor(props: ScoreCardsProps) {
    super(props);
    this.state = {
      data: createFilterData([]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
      institutionCode: ""
    };
  }

  handlePageChange = async (currentPage: number, pageSize: number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    const decodedToken = decodeToken(getCurrentUserSession().token || "");
    this.setState({ fetching: true });
    try {
      const scoreCardList = await scoringCardService.retrieveScoreCardByInstitutionCode(decodedToken?.["InstitutionCode"])
      const scoreCards: any = [];
      const totalLength = scoreCardList.data.length;
      const initial = (currentPage - 1) * pageSize;
      for (let i = initial; i < initial + pageSize; i++) {
        if (i === totalLength) {
          break;
        }
        scoreCards.push(scoreCardList.data[i]);
      }

      scoreCards.forEach(x => {
        x.channel = x.institutionCode === "000" ? "Qore" : "Client"
      });
      this.setState({
        tableItems: mapEntityList({
          entityList: scoreCards,
          properties: [
            { oldName: "id", newName: "id" },
            { oldName: "name", newName: "name" },
            { oldName: "description", newName: "description" },
            { oldName: "channel", newName: "channel" },
          ],
        }),
        currentPage,
        pageSize,
        totalSize: totalLength,
        fetching: false
      });
    } catch (ex) {
      // console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        this.setState({ fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        this.setState({ fetching: false });
      }
    } finally {
      this.setState({ fetching: false });
    }
  };

  handleOnExport = async () => { };

  fetchItemById = async (item: any) => {
    this.setState({ fetchingDetail: true });
    const config = await scoringCardService.retrieveScoreCardById(item.id);
    this.setState({ item: config.data, fetchingDetail: false });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {

    const decodedToken = decodeToken(getCurrentUserSession().token || "");
    this.handlePageChange(this.state.currentPage, this.state.pageSize);

    this.setState({ institutionCode: decodedToken?.["InstitutionCode"] })
  }

  render() {
    const {
      data,
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    const decodedToken = decodeToken(getCurrentUserSession().token || "");

    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Score Cards</b>
              </h3>
            </div>
            <ScoreCardsList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: createFilterData([
                  "institutionCategory",
                  "serviceOffering",
                ]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: [],
                item: {},
                jsonBefore: {},
                jsonAfter: {},
                fetchingTrail: false,
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
                fetchTrailItem,
                fetchingTrail,
                jsonAfter,
                jsonBefore,
                onToggleTrailModal,
                showTrailModal,
                trailItem,
                trailMapper,
              }) => (
                <Fragment>
                  <ScoreCardDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    toggleEditModal={onToggleEditModal}
                    showTrail={() => onToggleTrailModal(item)}
                    currentUserRoles={getCurrentUsersRoles()}
                    item={item}
                  />
                  <EditScoreCard
                    showEditModal={showEditModal}
                    toggleEditModal={(reloadDetails: boolean, item: any) => {
                      onToggleEditModal();
                      if (reloadDetails === true) {
                        this.fetchItemById(item);
                      }
                      this.setState({
                        showDetailsModal: !this.state.showDetailsModal,
                      });
                    }}
                    item={item}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="Score Card"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                if (decodedToken?.["InstitutionCode"] === "000") {
                                  onToggleDetailsModal()
                                }
                                else {
                                  if (item.channel !== "Qore") { onToggleDetailsModal() };
                                }
                              }}
                              handleOnExport={this.handleOnExport}
                            // disableViewDetails={}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></ScoreCardsList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ScoreCards;
